import React , {useState,useEffect} from 'react';
import Chart from 'react-apexcharts'
import { STUDENT } from '../constants';
const RevenueByGroup = (props) => {
    const { studentData } = props;
    // console.log(studentData.data,studentData.labels)
    const formatData  =(chartObj)=>{
        return {
            options: {
                colors:['#36b7b2', '#1498cf', '#f26189','#9a52a3'],
                labels: chartObj.map(obj=> obj.name),
                responsive: [{
                    options: {
                        legend: {
                            position: 'bottom'
                        }
                    }
                }],
                legend: {
                    horizontalAlign: 'right',
                }
            },
            series: props.type === STUDENT ?  chartObj.map(obj=> parseInt((obj.totalStudents || 0))) : chartObj.map(obj=> parseInt((obj.totalAmount || 0))) ,
        }
    }
    const [chartData, setChartData] = useState(formatData(studentData))
    useEffect(() => {
        setChartData(formatData(studentData))
    }, [studentData])
    return (
      <>
          <div id="chart" className="apexcharts-content">
                <Chart options={chartData.options} series={chartData.series} type="pie" height={350} />
            </div>
      </>
    );
  };
  
  export default RevenueByGroup;

